import {BusinessLayout} from "../../../layouts/Business";
import {FAQ} from "../../../components/business/faq";

export const BusinessFAQPage = () => {
    return (
        <BusinessLayout>
            <FAQ/>
        </BusinessLayout>
    )
}